/**
 * Created by jacky on 4/29/16.
 * @flow
 * @providesModule ImageViewer
 */
import React, { Component } from "react";
import {findDOMNode} from "react-dom";
import "./imageViewer.scss";

type ImageViewerPropsType = {
    data: Array<HTMLImageElement>;
    onEsc: () => void;
}
type ImageViewerStateType = {
    index: number;
}

export default class ImageViewer extends Component {
    props: ImageViewerPropsType;
    state: ImageViewerStateType = {
        index: 0
    }

    _p: () => void;

    _keyHandler(ev: any) {
        const idx = this.state.index;
        const data = this.props.data;
        let newIdx = null;

        switch (ev.keyCode) {
            case 37: // left
                if (idx - 1 > -1) {
                    newIdx = idx - 1;
                } else {
                    newIdx = data.length - 1;
                }
                break;
            case 39: // right
                if (idx + 1 < data.length) {
                    newIdx = idx + 1;
                } else {
                    newIdx = 0;
                }
                break;
            case 27: // esc
                this.props.onEsc();
                break;
        }

        if (newIdx !== null) {
            this.setState({index: newIdx});
            ev.preventDefault();
        }
    }

    componentDidMount() {
        this._p = this._keyHandler.bind(this);
        document.addEventListener('keydown', this._p);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this._p);
    }

    _onClick = (ev) => {
        const idx = this.state.index;
        const inc = window.innerWidth / 2 > ev.pageX ? -1 : 1;
        let nidx;

        if (inc > 0) {
            nidx = idx + inc < this.props.data.length ? idx + inc : 0;
        } else {
            nidx = idx + inc > -1 ? idx + inc : this.props.data.length - 1;
        }

        this.setState({index: nidx});
        ev.preventDefault();
    }

    _onNavClick = (ev) => {
        const trg = ev.target;
        const idx = parseInt(trg.dataset['index'], 10);
        this.setState({index: idx});
        ev.preventDefault();
    }

    render() {
        let ret;
        let nav = null;

        if (this.props.data instanceof Array) {
            const data = Array.prototype.slice.call(this.props.data);
            let i:number = 0;
            let items = data.map(p => {
                return (
                    <div className="clsCaruselItem" style={{left: i * 100 + '%'}} key={i++}>
                        <img src={p.src} onClick={this._onClick}/>
                    </div>
                );
            });

            i = 0;
            let navItems = data.map(p => {
                return (
                    <span key={i} data-index={i} className={this.state.index == i++ ? 'clsActive' : ''} />
                )
            });

            ret = (
                <div className="clsImageCarusel" style={{transform: `translateX(${this.state.index * -100}%)`}}>
                    {items}
                </div>
            );
            nav = (
                <div className="clsImageCaruselNav" onClick={this._onNavClick}>
                    {navItems}
                </div>
            )
        } else {
            ret = (
                <img src={(this.props.data: any).src} />
            );
        }

        return (
            <div className="clsImageViewer" onClick={e => e.defaultPrevented == false && this.props.onEsc()}>
                {ret}
                {nav}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Dialogs/ImageViewer/imageViewer.jsx